<template>
<v-list dense subheader class='pa-0' >
  <v-subheader class='overline' >Forms</v-subheader>
  <v-divider ></v-divider>
  <template v-if='request.loading'  >
    <center>
      <v-progress-circular color="amber" indeterminate width='2' class='ma-4' />
      <br/>
      <small>loading forms</small>
    </center>
  </template>
  <template v-else >
    <v-list-tile v-for='form in forms'
      @click='$emit("selected", form)'
      :key='form.id' >
      <v-list-tile-content>
        <v-list-tile-title>
          {{form.linked_form.title}}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if='forms && forms.length === 0' >
      <v-list-tile-content>
        <v-list-tile-title>
          No linked forms found
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </template>
</v-list>
</template>
<script>
export default {
  name: 'FormList',
  props: {
    relationshipId: { required: true }
  },
  data () {
    return {
      selectedForm: null,
      request: {
        resource: 'ag.integrations',
        extra: 'jotform/forms',
        params: {is_linked: 'true'},
        result: []
      }
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        this.get()
      }
    }
  },
  computed: {
    forms () {
      return this.request.result
    }
  },
  methods: {
    get () {
      return this.$request('get', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormList.vue?ee516d08